

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./Auth";
import PearlLogoLoader from "components/PearlLogoLoader";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, isAuthReady } = useAuth();
  const location = useLocation();

  if (!isAuthReady || isLoading) {
    return <PearlLogoLoader fullScreen message="Loading Pearl CRM..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return children;
}
